import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Container from '../container';
import MenuButton from './MenuButton';
import { getClassName } from '../../../utils/ui/classes';

const Navbar = ({
  showLeftMenuToggle,
  mainNavOpen,
  children,
  renderRightNav,
  renderMobileNav,
  logo,
  onToggleOpen,
}) => {
  const [open, setOpen] = useState(false);

  function toggleOpen() {
    setOpen(!open);
  }

  return (
    <nav className="fixed top-0 left-0 z-30 w-full bg-gray-800">
      <Container>
        <div className="flex items-center justify-between w-full h-16 gap-2">
          <div className="flex items-center min-w-0 flex-1">
            {showLeftMenuToggle && (
              <div className="hidden lg:block flex-shrink-0">
                <MenuButton open={mainNavOpen} onClick={onToggleOpen} />
              </div>
            )}
            <div className="flex-shrink-0">{logo}</div>
            <div className="hidden lg:ml-4 xl:ml-6 lg:block min-w-0 flex-1">
              <div className="relative flex items-center space-x-4 min-w-0">
                {children}
              </div>
            </div>
          </div>
          <div className="hidden lg:ml-6 lg:block flex-shrink-0">
            <div className="flex items-center">{renderRightNav()}</div>
          </div>
          <div className="flex lg:hidden flex-shrink-0">
            <MenuButton open={open} onClick={toggleOpen} />
          </div>
        </div>
        <div
          className={getClassName(
            'lg:hidden max-h-[calc(100vh-4rem)] overflow-y-auto',
            { block: open, hidden: !open },
          )}
        >
          {renderMobileNav(toggleOpen)}
        </div>
      </Container>
    </nav>
  );
};

Navbar.propTypes = {
  showLeftMenuToggle: PropTypes.bool,
  children: PropTypes.any,
  renderRightNav: PropTypes.func,
  renderMobileNav: PropTypes.func,
};
Navbar.defaultProps = {
  showLeftMenuToggle: false,
  renderRightNav: () => {},
  renderMobileNav: () => {},
};

export default Navbar;
